import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { FootnotesPipe, RouterLinkDirective, TrackingDirective } from '@hyundai/ng-common-lib';
import { M010C025IconLinkExternalComponent } from '../../010-buttons-and-links/m010-c025-icon-link-external/m010-c025-icon-link-external.component';
import type { M030C100BigShortFact } from './m030-c100-big-short-facts.interface';

@Component({
    selector: 'ui-m030-c100-big-short-facts',
    standalone: true,
    templateUrl: './m030-c100-big-short-facts.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLinkDirective, NgClass, M010C025IconLinkExternalComponent, FootnotesPipe, TrackingDirective],
})
export class M030C100BigShortFactsComponent {
    facts = input.required<M030C100BigShortFact[]>();

    externalLink = input<string | null>();
    externalLinkText = input<string>();

    primaryButton = input.required<string>();
    primaryButtonText = input.required<string>();
}
